<template>
    <app-layout title="Components">
        <table cellpadding="10">
            <thead>
                <tr>
                    <td></td>
                    <td>Primary</td>
                    <td>Secondary</td>
                    <td>Tertiary</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Active</td>
                    <td><button class="btn btn-primary">Get a Demo</button></td>
                    <td>
                        <button class="btn btn-secondary">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-tertiary">Get a Demo</button>
                    </td>
                </tr>
                <tr>
                    <td>Destructive</td>
                    <td></td>
                    <td>
                        <button class="btn btn-secondary destructive">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-tertiary destructive">Get a Demo</button>
                    </td>
                </tr>
                <tr>
                    <td>Disabled</td>
                    <td>
                        <button class="btn btn-primary disabled">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-secondary disabled">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-tertiary disabled">Get a Demo</button>
                    </td>
                </tr>
                <tr>
                    <td>Pressed</td>
                    <td>
                        <button class="btn btn-primary active">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-secondary active">Get a Demo</button>
                    </td>
                    <td>
                        <button class="btn btn-tertiary active">Get a Demo</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex gap-4">
            <Slider v-model="range" />
            {{ range }}
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import Slider from '@/Jetstream/Slider.vue';

export default {
    components: { AppLayout, Slider },
    data() {
        return {
            range: [500, 2000],
        };
    },
};
</script>
<style scoped></style>
